const countriesDataset = [
  {
    value: 2,
    label: 'אוגנדה',
  },
  {
    value: 3,
    label: 'אוזבקיסטן',
  },
  {
    value: 4,
    label: 'אוסטריה',
  },
  {
    value: 5,
    label: 'אוסטרליה',
  },
  {
    value: 6,
    label: 'אוקראינה',
  },
  {
    value: 7,
    label: 'אורוגוואי',
  },
  {
    value: 8,
    label: "אזרבייג'ן",
  },
  {
    value: 9,
    label: 'אי שלם',
  },
  {
    value: 10,
    label: 'איחוד האמירויות ערביות',
  },
  {
    value: 11,
    label: 'איטליה',
  },
  {
    value: 12,
    label: 'איי אלאנד',
  },
  {
    value: 13,
    label: 'איי בתולה, ארה"ב',
  },
  {
    value: 14,
    label: 'איי בתולה, בריטי',
  },
  {
    value: 15,
    label: 'איי חג המולד',
  },
  {
    value: 16,
    label: 'איי טורקס וקאיקוס',
  },
  {
    value: 17,
    label: 'איי מריאנה הצפוניים',
  },
  {
    value: 18,
    label: 'איי מרשל',
  },
  {
    value: 19,
    label: 'איי סיישל',
  },
  {
    value: 20,
    label: 'איי פוקלנד (מלווינס)',
  },
  {
    value: 21,
    label: 'איי פרו',
  },
  {
    value: 22,
    label: 'איי קומורו',
  },
  {
    value: 23,
    label: 'איי קוק',
  },
  {
    value: 24,
    label: 'איי קוקוס (קילינג)',
  },
  {
    value: 25,
    label: 'איי קיימן',
  },
  {
    value: 26,
    label: 'איים המינוריים חיצוניים של ארה"ב',
  },
  {
    value: 27,
    label: 'אינדונזיה',
  },
  {
    value: 28,
    label: 'איסלנד',
  },
  {
    value: 29,
    label: 'איראן, הרפובליקה האסלאמית של',
  },
  {
    value: 30,
    label: 'אירלנד',
  },
  {
    value: 31,
    label: 'אל סלבדור',
  },
  {
    value: 32,
    label: 'אלבניה',
  },
  {
    value: 33,
    label: "אלג 'ירייה",
  },
  {
    value: 34,
    label: 'אליס ופוטונה',
  },
  {
    value: 35,
    label: 'אנגולה',
  },
  {
    value: 36,
    label: 'אנדורה',
  },
  {
    value: 37,
    label: 'אנטארטיקה',
  },
  {
    value: 38,
    label: 'אנטיגואה וברבודה',
  },
  {
    value: 39,
    label: 'אנטרניקה',
  },
  {
    value: 40,
    label: 'אסטוניה',
  },
  {
    value: 41,
    label: 'אפגניסטן',
  },
  {
    value: 42,
    label: 'אפריקה מרכז',
  },
  {
    value: 43,
    label: 'אקוודור',
  },
  {
    value: 44,
    label: 'ארגנטינה',
  },
  {
    value: 45,
    label: 'ארובה',
  },
  {
    value: 46,
    label: 'אריתריאה',
  },
  {
    value: 47,
    label: 'ארמניה',
  },
  {
    value: 48,
    label: 'ארצות הברית',
  },
  {
    value: 49,
    label: 'אתיופיה',
  },
  {
    value: 50,
    label: 'בברבדוס',
  },
  {
    value: 51,
    label: 'בהאמה',
  },
  {
    value: 52,
    label: 'בובט אילנד',
  },
  {
    value: 53,
    label: 'בוטן',
  },
  {
    value: 54,
    label: 'בוטסואנה',
  },
  {
    value: 55,
    label: 'בולגריה',
  },
  {
    value: 56,
    label: 'בוליביה, מדינת רב-לאומית של',
  },
  {
    value: 57,
    label: 'בוניריה',
  },
  {
    value: 58,
    label: 'בוסניה והרצגובינה',
  },
  {
    value: 59,
    label: 'בורונדי',
  },
  {
    value: 60,
    label: 'בחריין',
  },
  {
    value: 61,
    label: 'בינין',
  },
  {
    value: 62,
    label: 'בלארוס',
  },
  {
    value: 63,
    label: 'בלגיה',
  },
  {
    value: 64,
    label: 'בלזי',
  },
  {
    value: 65,
    label: 'בנגלדש',
  },
  {
    value: 66,
    label: 'ברוניי דארוסלאם',
  },
  {
    value: 67,
    label: 'ברזיל',
  },
  {
    value: 68,
    label: 'בריטניה',
  },
  {
    value: 69,
    label: 'ברמודה',
  },
  {
    value: 70,
    label: "ג'ורג'יה",
  },
  {
    value: 71,
    label: "ג'יבוטי",
  },
  {
    value: 72,
    label: "ג'רזי",
  },
  {
    value: 73,
    label: 'גאבון',
  },
  {
    value: 74,
    label: 'גאמיקה',
  },
  {
    value: 75,
    label: 'גאנה',
  },
  {
    value: 76,
    label: 'גואטמלה',
  },
  {
    value: 77,
    label: 'גואם',
  },
  {
    value: 78,
    label: 'גוואדלופ',
  },
  {
    value: 79,
    label: 'גיאנה',
  },
  {
    value: 80,
    label: 'גיאנה הצרפתית',
  },
  {
    value: 81,
    label: 'גיברלטר',
  },
  {
    value: 82,
    label: 'גינאה',
  },
  {
    value: 83,
    label: 'גינאה ביסאו',
  },
  {
    value: 84,
    label: 'גיניאה המשוונית',
  },
  {
    value: 85,
    label: 'גמביה',
  },
  {
    value: 86,
    label: 'גרינלנד',
  },
  {
    value: 87,
    label: 'גרמניה',
  },
  {
    value: 88,
    label: 'גרנדה',
  },
  {
    value: 89,
    label: 'גרנזי',
  },
  {
    value: 90,
    label: 'דומיניקה',
  },
  {
    value: 91,
    label: 'דנמרק',
  },
  {
    value: 92,
    label: 'דרום אפריקה',
  },
  {
    value: 93,
    label: "דרום ג'ורג'יה ואיי סנדוויץ 'הדרומי",
  },
  {
    value: 94,
    label: 'דרום סודן',
  },
  {
    value: 95,
    label: 'האי הרד ואיי מקדונלד',
  },
  {
    value: 96,
    label: 'האי מן',
  },
  {
    value: 97,
    label: 'האיטי',
  },
  {
    value: 98,
    label: 'האיים המלדיביים',
  },
  {
    value: 99,
    label: 'האיים סבלברד ויאן מאיין',
  },
  {
    value: 100,
    label: 'הדמוקרטית העממית של לאוס הרפובליקה',
  },
  {
    value: 101,
    label: 'הודו',
  },
  {
    value: 102,
    label: 'הולנד',
  },
  {
    value: 103,
    label: 'הונג קונג',
  },
  {
    value: 104,
    label: 'הונגריה',
  },
  {
    value: 105,
    label: 'הונדורס',
  },
  {
    value: 106,
    label: 'הטריטוריה בריטית באוקיינוס ​​הודי',
  },
  {
    value: 107,
    label: 'הפדרציה הרוסית',
  },
  {
    value: 108,
    label: 'הרפובליקה הדומיניקנית',
  },
  {
    value: 109,
    label: 'הרפובליקה הערבית סורית',
  },
  {
    value: 110,
    label: "הרפובליקה הצ'כית",
  },
  {
    value: 111,
    label: 'וייט נאם',
  },
  {
    value: 112,
    label: 'ונואטו',
  },
  {
    value: 113,
    label: 'ונצואלה, הרפובליקה הבוליברית של',
  },
  {
    value: 114,
    label: 'ורקינה פאסו',
  },
  {
    value: 115,
    label: 'זימבבואה',
  },
  {
    value: 116,
    label: 'זמביה',
  },
  {
    value: 117,
    label: 'חוף השנהב',
  },
  {
    value: 118,
    label: "טג'יקיסטן",
  },
  {
    value: 119,
    label: 'טובאלו',
  },
  {
    value: 120,
    label: 'טונגה',
  },
  {
    value: 121,
    label: 'טוקלאו',
  },
  {
    value: 122,
    label: 'טורקיה',
  },
  {
    value: 123,
    label: 'טורקמניסטן',
  },
  {
    value: 124,
    label: 'טייוואן',
  },
  {
    value: 125,
    label: 'טנזניה, הרפובליקה המאוחדת של',
  },
  {
    value: 126,
    label: 'טריטוריות הדרומיות של צרפת',
  },
  {
    value: 127,
    label: 'טרינידד וטובגו',
  },
  {
    value: 128,
    label: 'יוון',
  },
  {
    value: 129,
    label: 'יפן',
  },
  {
    value: 130,
    label: 'ירדן',
  },
  {
    value: 131,
    label: 'ישראל',
  },
  {
    value: 132,
    label: 'כווית',
  },
  {
    value: 133,
    label: 'כס קדוש (קריית הוותיקן)',
  },
  {
    value: 134,
    label: 'כף ורדה',
  },
  {
    value: 135,
    label: 'לבנון',
  },
  {
    value: 136,
    label: 'לוב',
  },
  {
    value: 137,
    label: 'לוקסמבורג',
  },
  {
    value: 138,
    label: 'לטביה',
  },
  {
    value: 139,
    label: 'ליבריה',
  },
  {
    value: 140,
    label: 'ליטא',
  },
  {
    value: 141,
    label: 'ליכטנשטיין',
  },
  {
    value: 142,
    label: 'טוגו',
  },
  {
    value: 143,
    label: 'לסוטו',
  },
  {
    value: 144,
    label: 'מאוריטניה',
  },
  {
    value: 145,
    label: 'מאוריציוס',
  },
  {
    value: 146,
    label: 'מאלי',
  },
  {
    value: 147,
    label: 'מדגסקר',
  },
  {
    value: 148,
    label: 'מוזמביק',
  },
  {
    value: 149,
    label: 'מולדובה, הרפובליקה של',
  },
  {
    value: 150,
    label: 'מונגוליה',
  },
  {
    value: 151,
    label: 'מונטיסירט',
  },
  {
    value: 152,
    label: 'מונטנגרו',
  },
  {
    value: 153,
    label: 'מונקו',
  },
  {
    value: 154,
    label: 'מזרח טימור',
  },
  {
    value: 155,
    label: 'מיוטי',
  },
  {
    value: 156,
    label: 'מיקרונזיה, מדינות המאוחדות של',
  },
  {
    value: 157,
    label: 'מלאווי',
  },
  {
    value: 158,
    label: 'מלזיה',
  },
  {
    value: 159,
    label: 'מלטה',
  },
  {
    value: 160,
    label: 'מצרים',
  },
  {
    value: 161,
    label: 'מקאו',
  },
  {
    value: 162,
    label: 'מקדוניה, הרפובליקה היוגוסלבית לשעבר של',
  },
  {
    value: 163,
    label: 'מקסיקו',
  },
  {
    value: 164,
    label: 'מרוקו',
  },
  {
    value: 165,
    label: 'מרטיניק',
  },
  {
    value: 166,
    label: 'נאורו',
  },
  {
    value: 167,
    label: 'נורווגיה',
  },
  {
    value: 168,
    label: 'נורפלונג אלינד',
  },
  {
    value: 169,
    label: 'ניגריה',
  },
  {
    value: 170,
    label: 'ניו זילנד',
  },
  {
    value: 171,
    label: 'ניווה',
  },
  {
    value: 172,
    label: "ניז'ר",
  },
  {
    value: 173,
    label: 'מיאנמר',
  },
  {
    value: 174,
    label: 'ניקרגואה',
  },
  {
    value: 175,
    label: 'נמיביה',
  },
  {
    value: 176,
    label: 'נפאל',
  },
  {
    value: 177,
    label: 'סאו טומה ופרינסיפה',
  },
  {
    value: 178,
    label: 'סהרה המערבית',
  },
  {
    value: 179,
    label: 'סודן',
  },
  {
    value: 180,
    label: 'סוואזילנד',
  },
  {
    value: 181,
    label: 'סומליה',
  },
  {
    value: 182,
    label: 'סורינאם',
  },
  {
    value: 183,
    label: 'סיירתי לאון',
  },
  {
    value: 184,
    label: 'סין',
  },
  {
    value: 185,
    label: 'סינגפור',
  },
  {
    value: 186,
    label: 'סלובניה',
  },
  {
    value: 187,
    label: 'סלובקיה',
  },
  {
    value: 188,
    label: 'סמואה',
  },
  {
    value: 189,
    label: 'סמואה האמריקנית',
  },
  {
    value: 190,
    label: 'סן מרינו',
  },
  {
    value: 191,
    label: 'סנגל',
  },
  {
    value: 192,
    label: 'סנט ברתלמי',
  },
  {
    value: 193,
    label: 'סנט הלנה, אסנשן וטריסטן דה קונה',
  },
  {
    value: 194,
    label: 'סנט וינסנט והגרנדינים',
  },
  {
    value: 195,
    label: 'סנט לוסיה',
  },
  {
    value: 196,
    label: 'סנט מארטן (חלק הולנדי)',
  },
  {
    value: 197,
    label: 'סנט מרטין (חלק צרפתי)',
  },
  {
    value: 198,
    label: 'סנט קיטס ונוויס',
  },
  {
    value: 199,
    label: 'ספרד',
  },
  {
    value: 200,
    label: 'סרביה',
  },
  {
    value: 201,
    label: 'סרי לנקה',
  },
  {
    value: 202,
    label: 'עומאן',
  },
  {
    value: 203,
    label: 'עיראק',
  },
  {
    value: 204,
    label: 'ערב הסעודית',
  },
  {
    value: 205,
    label: 'פאלאו',
  },
  {
    value: 206,
    label: 'פוארטו ריקו',
  },
  {
    value: 207,
    label: 'פולין',
  },
  {
    value: 208,
    label: 'פולינזיה הצרפתית',
  },
  {
    value: 209,
    label: 'פורטוגל',
  },
  {
    value: 210,
    label: "פיג'י",
  },
  {
    value: 211,
    label: 'פיטקרן',
  },
  {
    value: 212,
    label: 'פייר ומיקלון',
  },
  {
    value: 213,
    label: 'פיליפינים',
  },
  {
    value: 214,
    label: 'פינלנד',
  },
  {
    value: 215,
    label: 'פלסטין, מדינת',
  },
  {
    value: 216,
    label: 'פנמה',
  },
  {
    value: 217,
    label: 'פפואה גינאה החדשה',
  },
  {
    value: 218,
    label: 'פקיסטן',
  },
  {
    value: 219,
    label: 'פרגוואי',
  },
  {
    value: 220,
    label: 'פרו',
  },
  {
    value: 221,
    label: "צ'אד",
  },
  {
    value: 222,
    label: "צ'ילה",
  },
  {
    value: 223,
    label: 'צרפת',
  },
  {
    value: 224,
    label: 'קובה',
  },
  {
    value: 225,
    label: 'קולומביה',
  },
  {
    value: 226,
    label: 'קונגו',
  },
  {
    value: 227,
    label: 'קונגו, הרפובליקה הדמוקרטית של',
  },
  {
    value: 228,
    label: 'קוסטה ריקה',
  },
  {
    value: 229,
    label: 'קוראסאו',
  },
  {
    value: 230,
    label: 'קוראה הדרומית',
  },
  {
    value: 231,
    label: 'קזחסטן',
  },
  {
    value: 232,
    label: 'קטאר',
  },
  {
    value: 233,
    label: 'קירגיזסטן',
  },
  {
    value: 234,
    label: 'קיריבאטי',
  },
  {
    value: 235,
    label: 'קלדוניה החדשה',
  },
  {
    value: 236,
    label: 'קמבודיה',
  },
  {
    value: 237,
    label: 'קמרון',
  },
  {
    value: 238,
    label: 'קנדה',
  },
  {
    value: 239,
    label: 'קניה',
  },
  {
    value: 240,
    label: 'קפריסין',
  },
  {
    value: 241,
    label: 'קרואטיה',
  },
  {
    value: 242,
    label: 'רואנדה',
  },
  {
    value: 243,
    label: 'רומניה',
  },
  {
    value: 244,
    label: 'ריאיונן',
  },
  {
    value: 245,
    label: 'רפובליקת קוריאה, העממית דמוקרטית של',
  },
  {
    value: 246,
    label: 'שוודיה',
  },
  {
    value: 247,
    label: 'שווייץ',
  },
  {
    value: 248,
    label: 'תאילנד',
  },
  {
    value: 249,
    label: 'תוניסיה',
  },
  {
    value: 250,
    label: 'תימן',
  },
  {
    value: 251,
    label: 'רוסיה',
  },
];

export default countriesDataset;
